import { observer } from "mobx-react";
import { Box, Typography } from "@material-ui/core";
import { useDocumentStore } from "../../../hooks/useDocumentStore";
import { Button, StandardDialog } from "@roc/ui";
import { Document } from "@roc/feature-types";
import { CustomTaskDialog } from "@roc/feature-general-tasks";
import { TodoStatus } from "@roc/feature-loan-details";
import { useEffect } from "react";
import { getConfirmLoanTermsTextAccepted, getConfirmLoanTermsTextPending, getCurrentLoanTermValues, getLoanTermApprovalValuesForDisplay } from "@roc/feature-loans";


type Props = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const AcceptLoanTermsDialog = observer((props: Props) => {
  const { open, onClose, loan, document } = props;
  const { documentStore } = useDocumentStore();
  const taskId = document?.taskId;
  const loanId = document?.loanId;

  const currentTerms = getCurrentLoanTermValues(loan);
  const underwriteTheLoanLoanTask = documentStore?.loanStore?.underwriteTheLoanTask;
  const loanTermApprovalValuesForDisplay = getLoanTermApprovalValuesForDisplay(documentStore?.loanStore.loanTermApprovalValues);

  const underwriterComment = underwriteTheLoanLoanTask?.attributes?.comment;
  const showUnderwriterComment = underwriterComment && documentStore.globalStore.isInternalPortal;

  const submit = async () => {
    documentStore?.loanStore.acceptTerms(loanId);
    onClose();
  };
  const isLineItemPending = document?.status === TodoStatus.PENDING;

  useEffect(() => {
    if (open && loanId) {
      documentStore?.loanStore.getUnderwriteTheLoanTask(loanId);
      documentStore?.loanStore.getLoanTermApprovalValues(loanId);
    }
  }, [loanId, open]);

  const AgreeTermsContent = () => {
    return <Box>
      <Typography variant="h5">
        Committee Terms
      </Typography>
      {!isLineItemPending && <Typography variant="body1" style={{ marginTop: '16px', marginBottom: '24px' }}>
        {getConfirmLoanTermsTextAccepted(loanTermApprovalValuesForDisplay?.initialLoanAmount, loanTermApprovalValuesForDisplay?.constructionHoldback, loanTermApprovalValuesForDisplay?.arltv, loanTermApprovalValuesForDisplay?.rate, loanTermApprovalValuesForDisplay?.interestReserveMonths)}
      </Typography>}
      {isLineItemPending && (<>
        <Typography variant="body1" style={{ marginTop: '16px', marginBottom: '24px' }}>
          {getConfirmLoanTermsTextPending(currentTerms?.initialLoanAmount, currentTerms?.constructionHoldback, currentTerms?.arltv, currentTerms?.rate, currentTerms?.interestReserveMonths)}
        </Typography>
        {showUnderwriterComment && (<>
          <Typography variant="body1" style={{ marginTop: '16px', fontWeight: 'bold' }}>
            <strong>Underwriter notes:</strong>
          </Typography>
          <Typography variant="body1" style={{ marginTop: '16px', marginBottom: '24px' }}>
            {underwriterComment}
          </Typography>
        </>)}
      </>)}
      {isLineItemPending && <>
        <Button
          style={{ marginRight: '8px', width: '240px' }}
          onClick={onClose}
          color="primary"
          variant="contained"
          testId="cancel"
        >
          Cancel
        </Button>
        <Button
          style={{ marginRight: '8px', width: '240px' }}
          onClick={submit}
          color="primary"
          variant="contained"
          testId="cancel"
        >
          Agree
        </Button>
      </>}
    </Box>
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Confirm Loan Terms"
          handleClose={onClose}
          dialogContent={<AgreeTermsContent />}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Confirm Loan Terms"
          maxWidth="sm"
          handleClose={onClose}
          dialogContent={<AgreeTermsContent />}
        />
      )}
    </>
  );
})